import * as martinez from 'martinez-polygon-clipping';
import { createCirclePolygon, createRectPolygon } from './shapes.js';
export const createCamlockHolePolygon = (hole)=>{
    const { $absCoords: center, width, height } = hole;
    const circle = createCirclePolygon({
        center,
        radius: height / 2
    });
    const rect = createRectPolygon({
        center,
        width,
        height
    });
    return martinez.intersection(circle, rect);
};

//# sourceMappingURL=camlock-hole.js.map